function createHeader() {    
    if (window.bf20.topPicksTitle && window.bf20.topPicksTitle.length > 0) {        
        return `<h2 id="topPicksTitle">${window.bf20.topPicksTitle}</h2>`;        
    } return '';  
}

function createSliderTarget () {    
    const bfTopPicksWrap = document.createElement('div');
    let currentElement = document.getElementById('sliderTarget--primaryCell');
    
    bfTopPicksWrap.id = 'bfTopPicks';
    bfTopPicksWrap.classList.add(`${window.bf20.brand}`);
    bfTopPicksWrap.innerHTML = `${createHeader()}<div id="topPicksCarousel" class="carousel bsCarousel "></div>`;
        
    currentElement.parentNode.insertBefore(bfTopPicksWrap,currentElement.nextSibling);
}

function hidePlaceHolderItems() {
    const carouselPlaceHolders = document.querySelectorAll('.banner--placeHolder');
    carouselPlaceHolders.forEach(item => {
        item.remove();
     });
}

function hidePlaceHolderPips() {
    document.querySelector('.slick-dots--placeHolder').style.visibility = 'hidden';
}

function addTopPicksConent (topPicksData) {
    const $sliderTarget = $sd("#topPicksCarousel");
    $sliderTarget.prepend(topPicksData);
    hidePlaceHolderItems();
    hidePlaceHolderPips();
}

function setCarouselHeight () {
    const sliderTarget = document.getElementById('topPicksCarousel');      
    const sliderHeight = sliderTarget.offsetHeight;
    if (sliderHeight > 0) {
        sliderTarget.style.height = `${sliderHeight}px`;
    }
}

const createSlider = (topPicksData) => {
    //createSliderTarget();
    //createHeader();
    if (window.bf20.deviceType !== 'desktop') {
        setCarouselHeight();
    }
    addTopPicksConent(topPicksData);
}

export default createSlider;